import { createSelector } from 'reselect';
const selectScribe = (state) => state.scribe;
export const selectSpeakerListened = createSelector([selectScribe], (scribe) => scribe.speakerListened);
export const selectScribeInURL = createSelector([selectScribe], (scribe) => scribe.scribeInURL);
